import { Box } from '@mui/material';
import React from 'react';
import { SORT_MODE_COUNTRY_POPULARITY } from '../../../atoms/encodedFormAtoms';
import { useDemoForm } from '../../../context/DemoFormContext';
import CountryFilterAutocomplete from './CountryFilterAutocomplete';
import SortBySelect from './SortBySelect';

/**
 * Primary Sort dropdown plus a conditional Country picker that flows
 * inline underneath it (only when sort mode is Country Popularity).
 * Extracted so the inclusion- and exclusion-results headers don't repeat
 * the same ~40 lines of layout/wiring.
 *
 * Both Sort and Country are 260px wide on sm+ (full-width on xs). The
 * outer wrapper sizes to its content (≈260px) so the controls row beside
 * it (Language Filter, Download List) doesn't get pushed around. Picker
 * flows inline rather than absolute-positioning so it can't overlap a
 * wrapped Download button at narrower viewport widths.
 */
const PrimarySortPicker: React.FC = () => {
  const { sortMode, isCountrySelectionInvalid } = useDemoForm();
  return (
    <Box
      onClick={(e) => e.stopPropagation()}
      sx={{
        flexShrink: 0,
        width: { xs: '100%', sm: 'auto' },
      }}
    >
      <SortBySelect />
      {sortMode === SORT_MODE_COUNTRY_POPULARITY && (
        <Box sx={{ mt: 0.75, width: { xs: '100%', sm: 260 }, minWidth: 0 }}>
          <CountryFilterAutocomplete
            error={isCountrySelectionInvalid}
            errorText="Pick at least one country"
          />
        </Box>
      )}
    </Box>
  );
};

export default PrimarySortPicker;
